import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStableVoice: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="stable-voice, stable-volume, voice-circle, voice-control"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><path d="M6.75 10V14" stroke="currentColor" strokeWidth="1.5"/><path d="M10.25 7V17" stroke="currentColor" strokeWidth="1.5"/><path d="M13.75 9V15" stroke="currentColor" strokeWidth="1.5"/><path d="M17.25 10V14" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconStableVoice;
